import { createClient } from '@supabase/supabase-js';

if (!process.env.REACT_APP_SUPABASE_URL) console.error('Handshake Error: Check @.env content');

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
console.log('Target URL:', supabaseUrl);
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

let supabase;
export let isSupabaseConnected = false;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase URL or anonymous key is missing. Please check your .env file.');
  // Create a dummy client to avoid crashing the app
  supabase = new Proxy({}, {
    get(target, prop) {
      return () => {
        console.warn(`Supabase method '${String(prop)}' called, but Supabase is not initialized.`);
        return Promise.resolve({ data: [], error: { message: 'Supabase not initialized' } });
      };
    }
  });
} else {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
  isSupabaseConnected = true;
}

export { supabase };